import { TMedAlert } from 'src/types/med-alert'
import { TPatientLocale } from 'src/types/locales'

const MIN_CHARACTERS = 4
const MAX_SUGGESTIONS = 5

export function getSuggestionsForLanguage(
  medAlerts: TMedAlert[],
  language: TPatientLocale,
  inputValue: string,
): TMedAlert[] {
  // Return empty if input is too short
  if (!inputValue || inputValue.length < MIN_CHARACTERS) {
    return []
  }

  const lowerCaseInput = inputValue.toLowerCase()

  // Filter medal alerts that have a label for this language and match the input
  const filtered = medAlerts.filter((medAlert) => {
    const labelForLanguage = medAlert.intlLabel?.[language]
    if (!labelForLanguage) return false

    return labelForLanguage.toLowerCase().includes(lowerCaseInput)
  })

  // Sort alphabetically by the language-specific label
  const sorted = filtered.slice().sort((a: TMedAlert, b: TMedAlert) => {
    const labelA = a.intlLabel?.[language] || ''
    const labelB = b.intlLabel?.[language] || ''
    return labelA.localeCompare(labelB)
  })

  // Return max 5 suggestions
  return sorted.slice(0, MAX_SUGGESTIONS)
}
